import React from "react";
import { Label } from "../../formInputs";
import { Tooltip } from "@material-ui/core";

type LabelWithIconProps = {
    label: string;
    isChanged: boolean;
    required?: boolean;
};

const LabelWithIcon: React.FC<LabelWithIconProps> = ({ label, isChanged, required = false }) => {
    const icon = !isChanged ? "🤖" : "😃";
    let toolTipText = isChanged ? "has been overriden by Admin." : "– Editing overrides automation";
    return (
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <Label label={label} required={required} />
                        <Tooltip title={`System-Generated Value ${toolTipText}`} arrow>
                            <span> {icon} </span>
                        </Tooltip>
            </div>
    );
};

export default LabelWithIcon;
